import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../setupStore';

interface DataIntegrationFailType {
  value: string | null;
}

const initialState: DataIntegrationFailType = {
  value: null,
};

export const DetectDataIntegrationFailSlice = createSlice({
  name: 'dataIntegrationFail',
  initialState,
  reducers: {
    detectDataIntegrationFail: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.value = action.payload;
    },
  },
});

export const { detectDataIntegrationFail } =
  DetectDataIntegrationFailSlice.actions;

export const selectDetectDataIntegrationFail = (state: RootState) =>
  state.detectDataIntegrationFail?.value;

export default DetectDataIntegrationFailSlice.reducer;
